export default __webpack_public_path__ + "41327071fd1e2db41cae049f091bbb6f.svg";